import { Typography } from '@mui/material';
import CaptionText from '../caption-text';
import RefundBreakdown from '../refund-breakdown';
import { FeeType } from '@acorn-portal/shared/src/services/cancellation-api';

interface RefundInformationProps {
	refundAmount: number;
	cancellationFee: number;
	totalRefundAmount: number;
	insurancePremiumTax: number;
	feeType: FeeType;
}

const RefundInformation = ({
	refundAmount,
	cancellationFee,
	totalRefundAmount,
	insurancePremiumTax,
	feeType,
}: RefundInformationProps) => {
	return (
		<>
			<Typography sx={{ mb: '16px' }}>
				Your refund will be paid to the account details on file within 7 to 10 working days.
			</Typography>
			<RefundBreakdown
				refundAmount={refundAmount}
				cancellationFee={cancellationFee}
				totalRefundAmount={totalRefundAmount}
				feeType={feeType}
			/>
			<CaptionText sx={{ mt: 1 }}>This includes a {insurancePremiumTax}% Insurance Premium Tax</CaptionText>
		</>
	);
};

export default RefundInformation;
